import request from '@/router/axios'

export function fetchList(query) {
  return request({
    url: '/basic/admin/tagtype/page',
    method: 'get',
    params: query
  })
}

export function addObj(obj) {
  return request({
    url: '/basic/admin/tagtype',
    method: 'post',
    data: obj
  })
}

export function getObj(id) {
  return request({
    url: '/basic/admin/tagtype/' + id,
    method: 'get'
  })
}

export function delObj(id) {
  return request({
    url: '/basic/admin/tagtype/' + id,
    method: 'delete'
  })
}

export function putObj(obj) {
  return request({
    url: '/basic/admin/tagtype',
    method: 'put',
    data: obj
  })
}

export function fetchItemList(query) {
  return request({
    url: `/basic/admin/tag${query.type === 2 ? '/classification' : '/topic'}/page`,
    method: 'get',
    params: query
  })
}

export function fetchRelateItemList(query,id) {
  return request({
    url: `/basic/admin/tag-relations/page/${id}`,
    method: 'get',
    params: query
  })
}

export function getItemObj(id) {
  return request({
    url: '/basic/tag/' + id,
    method: 'get'
  })
}

export function delItemObj(id) {
  return request({
    url: '/basic/admin/tag/' + id,
    method: 'delete'
  })
}
export function delRelateTagObj(id) {
  return request({
    url: '/basic/admin/tag-relations/' + id,
    method: 'delete'
  })
}

export function putItemObj(obj) {
  return request({
    url: '/basic/admin/tag',
    method: 'put',
    data: obj
  })
}

export function getAllTagsAdmin() {
  return request({
    url: '/basic/admin/tag',
    method: 'get'
  })
}

export function getAllTagTypesAdmin() {
  return request({
    url: '/basic/admin/tagtype',
    method: 'get'
  })
}

export function addNewTag(obj) {
  return request({
    url: '/basic/admin/tag',
    method: 'post',
    data: obj
  })
}

export function getTagsByType(query) {
  return request({
    url: `/basic/tag`,
    method: 'get',
    params: query
  })
}

export function approveTag (id) {
  return request({
    url: `/basic/admin/tag/approve/${id}`,
    method: 'put'
  })
}

export function rejectTag (id) {
  return request({
    url: `/basic/admin/tag/reject/${id}`,
    method: 'put'
  })
}

// 获取与帖子类别相关的主题
export function getRelatedTags(param) {
  return request({
    url: `/basic/tag/${param.id}/related-tags`,
    method: 'GET',
    params: {
      typeId: param.typeId,
    },
  });
}

// 创建标签
export function createTags(data) {
  return request({
    url: '/basic/tag',
    method: 'post',
    data,
  });
}

// 模糊查询标签
export function searchTags(param) {
  return request({
    url: '/basic/tag/word/page',
    method: 'GET',
    params: {
      keywords: param,
    },
  });
}

export function searchRelatedTag(id) {
  return request({
    url: `/basic/admin/tag-relations/page/${id}`,
    method: 'GET',
  });
}

//根据typeId查询tags
export function getItemObjByType(typeId) {
  return request({
    url: '/basic/tag/',
    method: 'get',
    params: {
      type: typeId,
    },
  })
}

//批量添加关联标签
export function addRelationTags(tagRelations) {
  return request({
    url: '/basic/admin/tag-relations/add',
    method: 'post',
    data: tagRelations
  })
}